<template>
    <div class="mobile-main">
        <div class="logo">
            <img src="@/assets/logo.png"/>
        </div>
        <div class="form-container">
            <a v-if="client.redirect_uri" @click="back" class="close"><img src="@/assets/close.png"/></a>
            <h1>Личный кабинет</h1>

            <div class="tab-buttons">
                <router-link class="tab-btn" :to="{ name: 'login' }">Вход</router-link>
                <router-link class="tab-btn" :to="{ name: 'register' }">Регистрация</router-link>
            </div>
            <router-view  @hideAll="hideAll"></router-view>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['client'];

export default {
    name: "MobileMain",
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        back(){
            window.location.href = this.client.redirect_uri;
        },
        hideAll(){
            this.$emit('hideAll');
        },
    },
};
</script>

<style lang="scss" scoped>
    .mobile-main *{
        font-family: 'Montserrat', sans-serif;
    }
    .logo{
        text-align: center;
        padding: 10px;
        height: 70px;
        box-sizing: border-box;
    }
    .mobile-main{
        background-color: #F3F5FC;
        height: 100vh;
        width: 100vw;
    }
    .form-container{
        position: relative;
        background-color: #fff;
        font-family: sans-serif;
        height: calc(100vh - 70px);
        padding: 0 10px 10px 10px;
        box-sizing: border-box;
        h1{
            padding: 32px 0;
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 23px;
            text-align: left;
            color: #2A2626;
        }
        .close{
            cursor: pointer;
            position: absolute;
            top: 32px;
            right: 10px;
            height: 23px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }
    .tab-buttons{
        border: 1px solid #9BB9EF;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        height: 32px;
        margin-bottom: 10px;
        border-radius: 4px;
        overflow: hidden;
    }
    .tab-btn{

        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        color: #3874E0;
        vertical-align: middle;

        flex-basis: 100%;
        flex: 1;
        box-sizing: border-box;
        padding: 8px;
        height: 100%;
        text-decoration: none;



        &.router-link-active {
            background: #3874E0;
            color: white;
        }
    }


</style>